let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kuBjS")).then(() => parcelRequire('4VXLm'));